
export interface ICSEventData {
  title: string;
  description?: string;
  startDate: Date;
  endDate: Date;
  location?: string;
  organizer?: {
    name: string;
    email: string;
  };
  attendee?: {
    name: string;
    email: string;
  };
}

export const generateICSFile = (eventData: ICSEventData): string => {
  const formatDate = (date: Date): string => {
    return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const escapeText = (text: string): string => {
    return text.replace(/[,;\\]/g, '\\$&').replace(/\n/g, '\\n');
  };

  const now = new Date();
  const uid = `${now.getTime()}@chronocal.io`;

  let icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//ChronoCal//ChronoCal Booking//EN',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${formatDate(now)}`,
    `DTSTART:${formatDate(eventData.startDate)}`,
    `DTEND:${formatDate(eventData.endDate)}`,
    `SUMMARY:${escapeText(eventData.title)}`,
  ];

  if (eventData.description) {
    icsContent.push(`DESCRIPTION:${escapeText(eventData.description)}`);
  }

  if (eventData.location) {
    icsContent.push(`LOCATION:${escapeText(eventData.location)}`);
  }

  if (eventData.organizer) {
    icsContent.push(`ORGANIZER;CN=${escapeText(eventData.organizer.name)}:mailto:${eventData.organizer.email}`);
  }

  if (eventData.attendee) {
    icsContent.push(`ATTENDEE;CN=${escapeText(eventData.attendee.name)}:mailto:${eventData.attendee.email}`);
  }

  icsContent.push('END:VEVENT');
  icsContent.push('END:VCALENDAR');

  return icsContent.join('\r\n');
};

export const downloadICSFile = (eventData: ICSEventData, filename: string = 'meeting.ics'): void => {
  const icsContent = generateICSFile(eventData);
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  window.URL.revokeObjectURL(url);
};
